import React,{ Component } from "react";
import { connect } from "react-redux";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import StagingConfigForm from "../StagingConfigForm/StagingConfigForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import {updateStagingConfig} from "../../../actions/actionStaging";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Staging",path:"/staging",isActive: false},
    {name: "UpdateStaging",path:"/updatestaging",isActive: true},
];

class UpdateStagingConfig extends Component{
    render(){
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Staging Config </strong>
                                </CardHeader>
                                <StagingConfigForm
                                    updateStagingConfig={this.props.updateStagingConfig}
                                    stagingConfigId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateStagingConfig.propTypes = {
    updateStagingConfig: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
        staging_configs: state.staging.staging_configs || [],
    }),
    dispatch => ({
        updateStagingConfig: (data) => dispatch(updateStagingConfig(data))
    }))(UpdateStagingConfig);